import {FormDefinition} from "../../../lib/forms";


export const FormVersao = {
  'fazendas': 3,
}

export const formDefLoja: FormDefinition = {
  ultimo_pedido: {name: 'ultimo_pedido', label: 'Último pedido', type: "date", required: true},

  bovigen_repro_total_quantidade: {name: 'bovigen_repro_total_quantidade', label: 'Quantidade', type: "number", required: false},
  bovigen_repro_total_valor: {name: 'bovigen_repro_total_valor', label: 'Valor', type: "currency", required: false},

  bovigen_lepto8_quantidade: {name: 'bovigen_lepto8_quantidade', label: 'Quantidade', type: "number", required: false},
  bovigen_lepto8_valor: {name: 'bovigen_lepto8_valor', label: 'Valor', type: "currency", required: false},

  bovigen_v4j5_quantidade: {name: 'bovigen_v4j5_quantidade', label: 'Quantidade', type: "number", required: false},
  bovigen_v4j5_valor: {name: 'bovigen_v4j5_valor', label: 'Valor', type: "currency", required: false},

  fosfosal_quantidade: {name: 'fosfosal_quantidade', label: 'Quantidade', type: "number", required: false},
  fosfosal_valor: {name: 'fosfosal_valor', label: 'Valor', type: "currency", required: false},

  observacoes: {name: 'observacoes', label: 'Observações', type: "text"},
};

export const formDefVeterinario: FormDefinition = {
  produtos_abordados: {name: 'produtos_abordados', label: 'Produtos abordados', type: "checkbox", required: true},
  observacoes: {name: 'observacoes', label: 'Observações', type: "text"},
};

export const formDefFazenda: FormDefinition = {
  quantidade_animais: {name: 'quantidade_animais', label: 'Quantidade animais', type: "number", required: false},
  faz_iatf: {name: 'faz_iatf', label: 'Faz IATF', type: "boolean", required: false},
  vacina_reprodutiva: {name: 'vacina_reprodutiva', label: 'Vacina reprodutiva que utiliza', type: "select", required: true},
  vacina_diarreia_pneumonia: {name: 'vacina_diarreia_pneumonia', label: 'Vacina diarréia e pneumonia que utiliza', type: "select", required: true},
  mineral_injetavel: {name: 'mineral_injetavel', label: 'Mineral injetável que utiliza', type: "select", required: true},
  observacoes: {name: 'observacoes', label: 'Observações', type: "text"},
};

export const formDefFazendaLeite: FormDefinition = {
  vacas_ordenhadas: {name: 'vacas_ordenhadas', label: 'Vacas em lactação', type: "number", required: true},
  intervalo_entre_partos: {name: 'intervalo_entre_partos', label: 'Intervalo entre partos (meses)', type: "number", required: false},

  // v2
  leite_vacas_secas: {name: 'leite_vacas_secas', label: 'Vacas secas', type: "number", required: true},
  leite_novilhas: {name: 'leite_novilhas', label: 'Novilhas', type: "number", required: true},
  leite_bezerras: {name: 'leite_bezerras', label: 'Bezerras/Terneiras', type: "number", required: true},

  // v3
  producao_litros_dia: {name: 'producao_litros_dia', label: 'Produção litros/dia', type: "number", required: true},
};

export const formDefFazendaCorte: FormDefinition = {
  femeas_idade_reprodutiva: {name: 'femeas_idade_reprodutiva', label: 'Fêmeas em idade reprodutiva', type: "number", required: false},
  touros: {name: 'touros', label: 'Touros', type: "number", required: false},
  data_inicio_em: {name: 'data_inicio_em', label: 'Data de início da EM', type: "date", required: false},
  femeas_submetidas_iatf: {name: 'femeas_submetidas_iatf', label: 'Fêmeas submetidas a IATF', type: "number", required: false},
  bezerros_nascidos: {name: 'bezerros_nascidos', label: 'Bezerros nascidos na estação', type: "number", required: false},
  bezerros_desmamados: {name: 'bezerros_desmamados', label: 'Bezerros desmamados', type: "number", required: false},

  // v2 cria
  corte_cria_vacas: {name: 'corte_cria_vacas', label: 'Vacas', type: "number", required: false},
  corte_cria_novilhas: {name: 'corte_cria_novilhas', label: 'Novilhas', type: "number", required: false},
  corte_cria_bezerros: {name: 'corte_cria_bezerros', label: 'Bezerros/Terneiros', type: "number", required: false},
  corte_cria_touros: {name: 'corte_cria_touros', label: 'Touros', type: "number", required: false},

  // v2 recria
  corte_recria_novilhas: {name: 'corte_recria_novilhas', label: 'Novilhas de 12 a 24 meses', type: "number", required: false},
  corte_recria_garrotes: {name: 'corte_recria_garrotes', label: 'Garrotes de 12 a 24 meses', type: "number", required: false},

  // v2 engorda
  corte_engorda_bois: {name: 'corte_engorda_bois', label: 'Bois acima de 24 meses', type: "number", required:  false},
  corte_engorda_femeas: {name: 'corte_engorda_femeas', label: 'Fêmeas acima de 24 meses', type: "number", required: false},

  // v2 confinamento
  corte_confinamento_machos: {name: 'corte_confinamento_machos', label: 'Machos', type: "number", required: false},
  corte_confinamento_femeas: {name: 'corte_confinamento_femeas', label: 'Fêmeas', type: "number", required: false},
};

export const listaVacinaReprodutiva: string[] = [
  'Bovigen Repro Total SE',
  'Bovigen Lepto 8',
  'Bovigen V4J5',
  'Cattle Master Gold',
  'Cattle Master 4+L5',
  'Bioabortogen',
  'Hiprabovis 9',
  'Fertiguard',
  'Poliguard',
  'Supravac 10',
  'Outro', 'Não utiliza',
];

export const listaVacinaDiarreiaPneumonia: string[] = [
  'Bovigen V4J5',
  'Scouguard',
  'Rotavec Corona',
  'Rotatec J5',
  'Outro', 'Não utiliza',
];

export const listaMineralInjetavel: string[] = [
  'Fosfosal',
  'Kit adaptador',
  'Roboforte',
  'Catosal',
  'Aminofort',
  'Outro', 'Não utiliza',
];
